<template>
  <modal size="4xl" @close="$emit('close')">
    <div class="w-full flex flex-wrap">
      <div class="w-full md:w-1/4">
        <user-admin-avatar-form :user="existing" @success="$emit('success')" />
      </div>
      <div class="w-full md:w-3/4 md:pl-4">
        <user-admin-update-form :existing="existing" @success="$emit('success')" />
      </div>
    </div>
  </modal>
</template>

<script>
import UserAdminUpdateForm from "@/components/Forms/UserAdminUpdateForm"
import UserAdminAvatarForm from "@/components/Forms/UserAdminAvatarForm"

export default {
  name: "UserAdminModal",
  components: {
    UserAdminAvatarForm,
    UserAdminUpdateForm
  },
  props: {
    existing: {
      required: true
    }
  }
}
</script>
